import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { Tooltip, TextField, MenuItem, Grid } from "@mui/material";
import { clientname, currentTenant, dataaccess, financialyearend, financialyearstart, logo, thousandsdisplay, userid, currency } from "../../Common/Credentials.js";
import moment from "moment";
import { spin } from "../../Common/NewLoader.jsx";
import SalesServices from "../SalesServices.js";
import { salesid } from "../../Common/Permissions.js";
import { NumericFormat } from "react-number-format";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService.js";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Menu from "../../Component/Menu.js";
import Header from "../../Component/Header.js";
import Footer from "../../Component/Footer.js";

// Import CSS
import '../../NewUI/NewUI.css';

// Import icons
import ViewIcon from "../../images/Icons/preview.png";
import UpArrow from "../../images/Icons/up-arrow.png";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TabSwitch from "../../NewUI/NewComponents/TabSwitch.jsx";

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class DnTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usercustomers: [],
      dndata: [],
      dncompleteddata: [],
      loading: false,
      activeTab: 'active',
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      currentPage: 1,
      itemsPerPage: 20,
      sortConfig: { key: 'customdnid', direction: 'asc' },
      filteredActiveData: [],
      filteredCompletedData: [],
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.sortData = this.sortData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.pdf = this.pdf.bind(this);
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'customdnid':
          aValue = a.customdnid || '';
          bValue = b.customdnid || '';
          break;
        case 'customsoid':
          aValue = a.customsoid || '';
          bValue = b.customsoid || '';
          break;
        case 'invoice':
          aValue = a.invoice || '';
          bValue = b.invoice || '';
          break;
        case 'customer':
          aValue = a.customer || '';
          bValue = b.customer || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'type':
          aValue = a.type || '';
          bValue = b.type || '';
          break;
        case 'status':
          aValue = a.status || '';
          bValue = b.status || '';
          break;
        case 'agent':
          aValue = a.agent || '';
          bValue = b.agent || '';
          break;
        case 'createdbyname':
          aValue = a.createdbyname || '';
          bValue = b.createdbyname || '';
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value, searchTerm = null) {
    if (value === null || value === undefined) return '0';

    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    const formattedNumber = Number(numericValue).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const fullFormattedString = `${prefix}${formattedNumber}`;

    if (searchTerm) {
      return this.highlightSearchText(fullFormattedString, searchTerm);
    }

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  pdf() {
    let pdfdata = this.state.activeTab === 'active' ? this.state.dndata : this.state.dncompleteddata;
    pdfdata = pdfdata.map((item) => ({
      ...item,
      createdAt: moment(item.createdAt).format("DD-MM-YYYY HH:mm:ss")
    }));

    const curdate = moment().format("DD-MM-YYYY HH:mm:ss");
    const columns = [
      { header: "DN Id", dataKey: "customdnid" },
      { header: "Saleorder Id", dataKey: "customsoid" },
      { header: "Customer", dataKey: "customer" },
      { header: "Date", dataKey: "createdAt" },
    ];

    var doc = new jsPDF("p", "pt", [842, 595]);
    autoTable(doc, {
      theme: "grid",
      startY: 120,
      didDrawPage: (HookData) => {
        HookData.settings.margin.top = 120;
      },
      body: pdfdata,
      columns: columns,
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageSize = doc.internal.pageSize;
      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      const footer = `Page ${i} of ${pageCount}`;

      doc.addImage(logo, "G IF", 40, 20, 60, 60, { baseline: "top" });
      doc.setFontSize(8);
      doc.text(`${curdate}`, 560, 20, "right");
      doc.setFontSize(16);
      doc.text(`${clientname}`, 180, 40, { baseline: "top" });
      doc.setFontSize(14);
      doc.text(`${this.state.activeTab === 'active' ? 'Active Delivery Notes' : 'Completed Delivery Notes'}`, 210, 70, { baseline: "top" });
      doc.line(0, 90, 600, 90);
      doc.setFontSize(10);

      doc.text(
        footer,
        pageWidth / 2 - doc.getTextWidth(footer) / 2,
        pageHeight - 15,
        { baseline: "bottom" }
      );
    }
    doc.save(`${this.state.activeTab === 'active' ? 'Active' : 'Completed'}DeliveryNotes.pdf`);
  }

  handleFromDateChange = (date) => {
    this.setState({
      fromdate: date,
      todate:
        moment(date).diff(this.state.todate, "days") >= 0
          ? this.state.todate
          : date,
    });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  handleDateChange = () => {
    this.refreshCompleted(this.state.fromdate, this.state.todate);
  };

  refresh() {
    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess: dataaccess,
    };

    SalesServices.GetAllDn(datadao)
      .then((response) => {
        const filteredData = response.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter((e) =>
            this.state.usercustomers.length === 0
              ? e
              : this.state.usercustomers.includes(e.customer)
          );

        this.setState({
          dndata: filteredData,
          filteredActiveData: filteredData,
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  refreshCompleted = (from, to) => {
    let datadao = {
      tenantid: currentTenant,
      startdate: from,
      enddate: to,
      userid: userid,
      dataaccess: dataaccess,
    };

    SalesServices.GetAllDnCompleted(datadao).then((response) => {
      const filteredData = response.data
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
        .filter((e) =>
          this.state.usercustomers.length === 0
            ? e
            : this.state.usercustomers.includes(e.customer)
        );

      this.setState({
        dncompleteddata: filteredData,
        filteredCompletedData: filteredData,
        loading: false,
      });
    });
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });
    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      this.setState({
        usercustomers:
          res.data === "" || res.data === undefined
            ? []
            : res.data.customers.split(","),
      })
    );
    this.refresh();
    this.refreshCompleted(moment().subtract(7, "days"), moment());

    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  updateFilteredData() {
    const { searchTerm, activeTab, dndata, dncompleteddata } = this.state;

    const filterData = (data) => {
      if (!searchTerm.trim()) return data;

      const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

      return data.filter((item) => {
        const checkFields = [
          item.customdnid,
          item.customsoid,
          item.customer,
          item.agent,
          item.createdbyname,
          item.type,
          item.status,
          item.invoice,
        ];

        return checkFields.some((field) => {
          if (field === undefined || field === null) return false;

          const raw = String(field);
          const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

          return (
            cleanField.includes(cleanSearch) ||
            raw.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      });
    };

    this.setState({
      filteredActiveData: filterData(dndata),
      filteredCompletedData: filterData(dncompleteddata),
      currentPage: 1,
    });
  }

  getCurrentData() {
    const { activeTab, filteredActiveData, filteredCompletedData } = this.state;
    return activeTab === 'active' ? filteredActiveData : filteredCompletedData;
  }

  getCurrentPageData() {
    const currentData = this.getCurrentData();
    const { currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(currentData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  renderTabs() {
    const { activeTab, filteredActiveData, filteredCompletedData, isMobile } = this.state;

    const tabs = [
      { key: 'active', label: 'Active', count: filteredActiveData.length },
      { key: 'completed', label: 'Completed', count: filteredCompletedData.length },
    ];

    return (
      <div className="UI-quotation-tabs-container !tw-bg-white !tw-border-none !tw-pt-2">
        {/* {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${activeTab === tab.key ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={() => this.setState({
              activeTab: tab.key,
              currentPage: 1,
              sortConfig: { key: 'customdnid', direction: 'asc' }
            })}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))} */}

        <TabSwitch value={activeTab} onChange={(value) => this.setState({ activeTab: value })} options={[
          { value: 'active', label: 'Active', count: filteredActiveData.length },
          { value: 'completed', label: 'Completed', count: filteredCompletedData.length },
        ]} />

        {/* Date Filters for Completed tab */}
        {activeTab === 'completed' && (
          <div className="UI-date-filter-container">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                <DatePicker
                  label="From Date"
                  value={this.state.fromdate}
                  onChange={this.handleFromDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: isMobile ? '100%' : '140px' }}
                    />
                  )}
                />
                <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                <DatePicker
                  label="To Date"
                  value={this.state.todate}
                  onChange={this.handleToDateChange}
                  minDate={this.state.fromdate}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: isMobile ? '100%' : '140px' }}
                    />
                  )}
                />
                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={this.handleDateChange}
                  onMouseEnter={() => this.setState({ hovered: 'apply' })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                  style={isMobile ? { width: '100%', marginTop: '8px' } : {}}
                >
                  <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
                  Apply
                </button>
              </div>
            </LocalizationProvider>
          </div>
        )}
      </div>
    );
  }

  renderPagination() {
    const { currentPage, itemsPerPage, isMobile } = this.state;
    const currentData = this.getCurrentData();

    if (currentData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(currentData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, currentData.length)} of {currentData.length} delivery notes
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const currentData = this.getCurrentData();

    if (currentData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No delivery notes found matching your search' : 'No delivery notes available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customdnid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customdnid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    DN Id
                    <this.SortIndicator columnKey="customdnid" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customsoid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customsoid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Saleorder Id
                    <this.SortIndicator columnKey="customsoid" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'invoice' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('invoice')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Tax Invoice Id
                    <this.SortIndicator columnKey="invoice" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customer' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customer')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Customer
                    <this.SortIndicator columnKey="customer" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'agent' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('agent')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Agent
                    <this.SortIndicator columnKey="agent" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdbyname' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('createdbyname')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Created By
                    <this.SortIndicator columnKey="createdbyname" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('createdAt')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Date
                    <this.SortIndicator columnKey="createdAt" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'type' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('type')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Type
                    <this.SortIndicator columnKey="type" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('status')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Status
                    <this.SortIndicator columnKey="status" />
                  </div>
                </th>
                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((item) => (
                <tr
                  key={item.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                  onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* DN ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}
                  >
                    {this.highlightSearchText(item.customdnid, this.state.searchTerm)}
                  </td>

                  {/* SALEORDER ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {item.customsoid === null ? (
                      "Direct"
                    ) : (
                      <Link
                        to={{ pathname: "/saleorderdetails" }}
                        state={{
                          id: item.soid,
                          bvstatus: 0,
                        }}
                        className="UI-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {this.highlightSearchText(item.customsoid, this.state.searchTerm)}
                      </Link>
                    )}
                  </td>

                  {/* TAX INVOICE ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {item.invoice && (
                      <Link
                        to={{ pathname: "/viewsalesinvoice" }}
                        state={{
                          id: item.invid,
                          pagename: "Tax Invoice Details",
                          type: "Tax Invoice",
                        }}
                        className="UI-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {this.highlightSearchText(item.invoice, this.state.searchTerm)}
                      </Link>
                    )}
                  </td>

                  {/* CUSTOMER */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.customer, this.state.searchTerm)}
                  </td>

                  {/* AGENT */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.agent || 'Direct', this.state.searchTerm)}
                  </td>

                  {/* CREATED BY */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.createdbyname, this.state.searchTerm)}
                  </td>

                  {/* DATE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {moment(item.createdAt).format("DD-MM-YYYY HH:mm:ss")}
                  </td>

                  {/* TYPE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.type, this.state.searchTerm)}
                  </td>

                  {/* STATUS */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    <span className={`UI-status-badge ${item.status === 'Completed' ? 'UI-status-completed' :
                      item.status === 'Pending' ? 'UI-status-pending' :
                        'UI-status-active'}`}>
                      {this.highlightSearchText(item.status, this.state.searchTerm)}
                    </span>
                  </td>

                  {/* ACTION BUTTONS */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    <div className="UI-action-buttons">
                      <Link
                        to={{ pathname: "/viewdeliverynote" }}
                        state={{
                          id: item.dnid,  // This should be the internal ID
                          soid: item.customsoid,
                        }}
                        className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                        style={{ textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={() =>
                          this.setState({ isActionHovered: `view-${item.id}` })
                        }
                        onMouseLeave={() => this.setState({ isActionHovered: null })}
                      >
                        <Tooltip title="View Details" arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={ViewIcon}
                            alt="View"
                            className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${item.id}` ? 'UI-edit-icon-hover' : ''}`}
                          />
                        </Tooltip>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {this.renderPagination()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Delivery Notes", path: null }]} />
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Delivery Notes
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      Manage delivery note records
                    </p>
                  </div>

                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        placeholder="Search delivery notes..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        className="UI-mobile-search-input"
                      />
                    )}

                    <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                      {/* Desktop Search Toggle */}
                      {!isMobile && (
                        <div
                          className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                          onClick={() => {
                            if (!this.state.showSearch) this.setState({ showSearch: true });
                          }}
                          onMouseEnter={() => this.setState({ hovered: "search" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i
                            className="fa fa-search UI-search-icon"
                          />
                          {!this.state.showSearch && "Search"}
                          {this.state.showSearch && (
                            <input
                              type="text"
                              placeholder="Search delivery notes..."
                              value={this.state.searchTerm}
                              onChange={(e) => this.handleSearch(e.target.value)}
                              className="UI-search-input"
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (this.state.searchTerm.trim() === "") {
                                  this.setState({ showSearch: false });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {/* Export button */}
                      {(salesid === "2" || salesid === "3") && (
                        <button
                          className={`UI-btn UI-btn-outline ${this.state.hovered === "export" ? 'UI-btn-outline-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                          onClick={this.pdf}
                          onMouseEnter={() => this.setState({ hovered: "export" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-pdf" /> {isMobile ? "Export" : "Export"}
                        </button>
                      )}

                      {/* New Delivery Note button */}
                      {(salesid === "2" || salesid === "3") && (
                        <Link
                          as="button"
                          className={`UI-btn UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                          to={{ pathname: "/newdeliverynote" }}
                          state={{ id: -1, pagename: "New Delivery Note" }}
                          onMouseEnter={() => this.setState({ hovered: "new" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-plus" /> {isMobile ? "New" : "New Delivery Note"}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTabs()}
                  <div style={{ marginTop: '16px' }}>
                    {this.renderTable()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(DnTable);